import React from 'react'
import clsx from 'clsx'
import styles from './styles.module.scss'

interface CategoryLabelsProps {
  categories: string[]
  className?: string
}

const CategoryLabels: React.FC<CategoryLabelsProps> = ({ categories, className }) => {
  if (categories.length === 0) return null

  return (
    <ul className={clsx(styles.categoryLabels, className)}>
      {categories.map((category) => (
        <li key={category} className={styles.categoryItem}>
          {category}
        </li>
      ))}
    </ul>
  )
}

export default CategoryLabels
